import { useNavigate } from "react-router-dom"
import { isAdmin } from "../../common/utils"
import Button from "./button"
import SearchBar from "./searchBar"

interface AddAndSearchBarProps {
    route: string,
    searchLabel: string,
    onSearch: (value:string) => void
}

const AddAndSearchBar = ({ route, searchLabel, onSearch }: AddAndSearchBarProps) => {
    const history = useNavigate();
    return <>
        <div className="w-full">
            <div className="hidden w-full md:flex flex-row justify-end">
                <SearchBar
                    onSearch={onSearch}
                    placeHolder={searchLabel}
                />
                {isAdmin() && (
                    <div className=" mt-2 mb-2 ml-2 space-x-4">
                        <Button
                            label="Ajouter"
                            onClick={() => history(route)}
                        />
                    </div>
                )}
            </div>
            <div className="w-full flex flex-row justify-end md:hidden">
                <SearchBar
                    onSearch={onSearch}
                    placeHolder={searchLabel}
                />
                {isAdmin() && (
                    <div className="relative mt-2 mb-2 ml-2">
                        <Button
                            label="Ajouter"
                            onClick={() => history(route)}
                        />
                    </div>
                )}
            </div>
        </div>
    </>
}

export default AddAndSearchBar